// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "LazyIdentificationForm" + "." + "b449ad422c83743160f1" + ".css";
};